import { useFormContext } from "react-hook-form";
import { StationAutocomplete } from "@/components/fields/station-autocomplete";
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import type { Station } from "@/models/station";

interface FormStationAutocompleteProps {
	name: string;
	label?: string;
	placeholder?: string;
	required?: boolean;
	disabled?: boolean;
	onStationSelect?: (station: Station | null) => void;
}

export function FormStationAutocomplete({
	name,
	label,
	placeholder,
	required,
	disabled,
	onStationSelect,
}: FormStationAutocompleteProps) {
	const form = useFormContext();

	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field, fieldState }) => (
				<FormItem>
					{label && <FormLabel required={required}>{label}</FormLabel>}
					<FormControl>
						<StationAutocomplete
							placeholder={placeholder}
							value={field.value}
							onSelect={(station) => {
								field.onChange(station);
								onStationSelect?.(station);
							}}
							disabled={disabled}
							error={!!fieldState.error}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	);
}
